import create from "zustand";
import { persist } from "zustand/middleware";

type FilterStatusState = {
  isFilterOpen: boolean;
  setIsFilterOpen: (isOpen: boolean) => void;
};

const useFilterStatusStore = create(
  persist<FilterStatusState>(
    (set) => ({
      isFilterOpen: false,
      setIsFilterOpen: (isFilterOpen) => set({ isFilterOpen }),
    }),
    {
      name: "filter-status",
    }
  )
);

const useFilterStatus = () => {
  const { isFilterOpen, setIsFilterOpen } = useFilterStatusStore();

  return { isFilterOpen, setIsFilterOpen };
};

export default useFilterStatus;
